import { ProductDto } from '@/shared/interfaces';

export type AiNurseRequest = {
    Subject: string;
    Message: string;
    HasAttachments: boolean;
    IsChild: boolean;
    IsEnglish: boolean;
};

export type AiNurseQuestionResponse = {
    NeedsFollowup: boolean;
    Questions?: string;
    SuggestAttachment: boolean;
};

export enum AiNurseStep {
    Modal = 'modal',
    Question = 'question',
    Overview = 'overview',
    Completed = 'completed',
    // DescribeProblem.tsx reacts to AiNurseStep = Skipped by moving on to next step.
    // But we only want to do this once (to preserve back nav) so it also sets AiNurseStep = Disabled
    Skipped = 'skipped',
    Disabled = 'disabled',
}

export type ProductOption = ProductDto & {
    IsDisabledForSelectedPatient: boolean;
};
